import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
interface PageHeroProps {
  title: string;
  lead: string;
  breadcrumb: string;
  children?: React.ReactNode;
}
export function PageHero({
  title,
  lead,
  breadcrumb,
  children
}: PageHeroProps) {
  return <section className="bg-midnight-950 text-champagne-50" data-id="element-166" data-mp="22zd9zofkl29">
      <div className="mx-auto max-w-site px-6 pb-16 pt-12 lg:px-10 lg:pb-24 lg:pt-16" data-id="element-167" data-mp="25c1uvop1toa">
        <nav aria-label="Breadcrumb" data-id="element-168" data-mp="ptv6n18jbobm">
          <ol className="flex items-center gap-1.5 text-xs text-champagne-100/55" data-id="element-169" data-mp="urwppm5ynnn3">
            <li data-id="element-170" data-mp="g3a0msqj7hio">
              <Link to="/" className="transition-colors duration-150 ease-out hover:text-champagne-100" data-id="element-171" data-mp="g3tkwg3nmhzv">
                Home
              </Link>
            </li>
            <li aria-hidden="true" data-id="element-172" data-mp="l0a7h5v7goau">
              <ChevronRightIcon className="h-3.5 w-3.5" data-id="element-173" data-mp="18rfmjitbnck3" />
            </li>
            <li aria-current="page" className="text-champagne-300" data-id="element-174" data-mp="1dinxijaav5zd">
              {breadcrumb}
            </li>
          </ol>
        </nav>
        <h1 className="mt-8 max-w-4xl font-serif text-5xl leading-[1.05] md:text-6xl" data-id="element-175" data-mp="32jdhskdrvhbr">{title}</h1>
        <p className="mt-6 max-w-2xl text-lg leading-relaxed text-champagne-100/75" data-id="element-176" data-mp="2xk0mdb8u51xk">{lead}</p>
        {children && <div className="mt-10" data-id="element-177" data-mp="3c96q9cimbgbs">{children}</div>}
      </div>
    </section>;
}